import { UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query"
import axios from "axios"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const applyOptions = (options?: UseQueryOptions): UseQueryOptions<any> => {
  return {
    ...options,
    suspense: options?.suspense ?? true,
  }
}

// Useful links
export const useUsefulLinks = (options?: UseQueryOptions): UseQueryResult<{ name: string; url: string }[], unknown> => {
  return useQuery<{ name: string; url: string }[]>(
    ["links"],
    async () => {
      const { data } = await axios.get<{ name: string; url: string }[]>(`/api/usefullinks`)

      return data
    },
    applyOptions(options)
  )
}
